import { useEffect, useState } from "react";
import Spinner from "../Spinner";
import CancelReason from "../../services/cancelReason";
import SelectInput from "../SelectInput";

type CancelReasonSelectProps = {
    name: string;
    label?: string;
    onChange?: (name: string, value: string) => void;
    type?: "cancelamento" | "noshow";
    value?: string;
    required?: boolean;
    onlyInput?: boolean;
    error?: string;
    placeholder?: string;
    onBlur?: (name: string, value: string) => void;
};

const CancelReasonInput = ({ name, placeholder, label, onChange, onBlur, type, value, error = "", ...props }: CancelReasonSelectProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [options, setOptions] = useState([]);

    useEffect(() => {
        setLoading(true);
        CancelReason.list({ type })
            .then(res => {
                const items = res.map(option => ({ label: option.title, value: option.id }))

                setOptions(items)
            })
            .finally(() => setLoading(false));
    }, [type]);


    return (
        <>
            {loading ? (
                <Spinner />
            ) : (
                <SelectInput
                    name={name}
                    placeholder={placeholder}
                    label={label}
                    options={options}
                    onChange={onChange}
                    value={value}
                    onBlur={onBlur}
                    error={error}
                    {...props}
                />
            )}
        </>
    );
};

export default CancelReasonInput;
